module.exports = __webpack_public_path__ + "img/Not_found_dog.5952bc59.svg";